import { render, staticRenderFns } from "./AddSkill.vue?vue&type=template&id=7fcb0b2c&scoped=true"
import script from "./AddSkill.vue?vue&type=script&lang=js"
export * from "./AddSkill.vue?vue&type=script&lang=js"
import style0 from "./AddSkill.vue?vue&type=style&index=0&id=7fcb0b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb0b2c",
  null
  
)

export default component.exports